import { ComponentPropsWithoutRef } from 'react';
import clsx from 'clsx';

/**
 * A simple horizontal divider component.
 */
export function Divider({
  className,
  soft = false,
  ...props
}: { 
  /** Whether to use a softer color for the divider. */
  soft?: boolean 
} & ComponentPropsWithoutRef<'hr'>) {
  return (
    <hr
      role="presentation"
      {...props}
      className={clsx(
        className,
        'w-full border-t',
        soft && 'border-gray-950/5 dark:border-white/5',
        !soft && 'border-gray-950/10 dark:border-white/10'
      )}
    />
  );
}
